


































export default

	# 'card' is object like { id:String, image:Array, product:Object }
	# 'image' and 'product' fields are required in the CMS
	props: card: Object

	data: -> loading: false

	computed:

		# Accessor helpers
		product: -> @card.product
		variant: -> @product.variants[0]

		# Pass through apect ratio
		styles: -> '--image-aspect': @imageAspect

		# Figure out the image aspect ratio
		imageAspect: ->
			return unless image = @card.image?[0]
			image.width / image.height

	methods:

		# Add this to cart
		addToCard: ->
			@loading = true
			if @product.isBundle
			then await @$store.dispatch 'cart/addBundle',
				variantIds: @variant.bundleVariantIds
				bundleSlug: @variant.bundleSlug
			else await @$store.dispatch 'cart/addItem',
				id: @variant.id
			@$store.commit 'cart/open'
			@loading = false

